import React from "react";
import { NavLink, useLocation } from "react-router-dom";
import { ReactComponent as DashboardIcon } from "../../../../assets/icons/dashboardIcon.svg";
import { ReactComponent as MainPanelIcon } from "../../../../assets/icons/mainPanelIcon.svg";
import { ReactComponent as CoursesIcon } from "../../../../assets/icons/coursesIcon.svg";
import { ReactComponent as TeachersIcon } from "../../../../assets/icons/teachersIcon.svg";
import { ReactComponent as StudentsIcon } from "../../../../assets/icons/studentsIcon.svg";
import { ReactComponent as CompanyIcon } from "../../../../assets/icons/sidebar/company.svg";
import { ReactComponent as TableIcon } from "../../../../assets/icons/tableIcon.svg";
// import { ReactComponent as SalaryIcon } from "../../../../assets/icons/salaryIcon.svg";
import { ReactComponent as ExpensesIcon } from "../../../../assets/icons/expensenIcon.svg";
import { ReactComponent as SalesIcon } from "../../../../assets/icons/sidebar/sales.svg";
import { ReactComponent as IncomesIcon } from "../../../../assets/icons/incomesIcon.svg";
import { ReactComponent as FeedBacksIcon } from "../../../../assets/icons/sidebar/feedbacks-icon.svg";
import { ReactComponent as AdminIcon } from "../../../../assets/icons/sidebar/users-01.svg";
import { ReactComponent as GroupIcon } from "../../../../assets/icons/sidebar/group-svgrepo-com.svg";
import { ReactComponent as CareerIcon } from "../../../../assets/icons/sidebar/work-case-filled-svgrepo-com (1).svg";
import { ReactComponent as EventsIcon } from "../../../../assets/icons/sidebar/events.svg";
import { ReactComponent as SyllabusIcon } from "../../../../assets/icons/sidebar/syllabus-svgrepo-com.svg";
import { ReactComponent as DiplomaIcon } from "../../../../assets/icons/sidebar/diploma.svg";
import { ReactComponent as RoomIcon } from "../../../../assets/icons/room-icon.svg";
import { ReactComponent as ReportIcon } from "../../../../assets/icons/sidebar/report.svg";
import { ReactComponent as AdvertisingIcon } from "../../../../assets/icons/advertising.svg";
import { ReactComponent as ContractTypeIcon } from "../../../../assets/icons/sidebar/contract-type.svg";
import { ReactComponent as NotificationIcon } from "../../../../assets/icons/Notification.svg";
import { ReactComponent as SalaryIcon } from "../../../../assets/icons/salary.svg";
import { ReactComponent as QuarterlyPlan } from "../../../../assets/icons/quarterly-plan.svg";
import { useSelector } from "react-redux";

const SidebarSuperAdmin = ({ closeSidebar }) => {
  const location = useLocation();
  const groupsNav = ["/groups/current", "/groups/waiting", "/groups/ended"];
  const { hasNewNotification } = useSelector((state) => state.notifications);

  return (
    <ul className="sidebar-nav-list">
      <li>
        <NavLink to="/notifications" onClick={closeSidebar}>
          <div style={{ position: "relative" }}>
            {hasNewNotification > 0 && (
              <div
                style={{
                  width: "12px",
                  height: "12px",
                  borderRadius: "50%",
                  backgroundColor: "#ed444e",
                  position: "absolute",
                  right: "8px",
                  top: "-2px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <span style={{ fontSize: "8px", color: "white" }}>
                  {hasNewNotification}
                </span>
              </div>
            )}
            <NotificationIcon />
          </div>
          Bildirişlər
        </NavLink>
      </li>
      <li>
        <NavLink to="/dashboard" onClick={closeSidebar}>
          <DashboardIcon />
          İdarəetmə paneli
        </NavLink>
      </li>
      <li>
        <NavLink to="/report" onClick={closeSidebar}>
          <ReportIcon />
          Hesabatlar paneli
        </NavLink>
      </li>
      <li>
        <NavLink to="/lesson" onClick={closeSidebar} className="admin">
          <TableIcon />
          Cədvəl
        </NavLink>
      </li>
      <li>
        <NavLink to="/students" onClick={closeSidebar}>
          <StudentsIcon />
          Tələbələr
        </NavLink>
      </li>{" "}
      <li>
        <NavLink to="/company" onClick={closeSidebar}>
          <CompanyIcon />
          Şirkətlər
        </NavLink>
      </li>
      <li>
        <NavLink to="/teachers" onClick={closeSidebar}>
          <TeachersIcon />
          Təlimçilər
        </NavLink>
      </li>
      <li>
        <NavLink to="/teachers-payments" onClick={closeSidebar}>
          <SalaryIcon />
          Təlimçilərin əmək haqqı
        </NavLink>
      </li>
      <li>
        <NavLink to="/courses" onClick={closeSidebar}>
          <CoursesIcon />
          Fənlər
        </NavLink>
      </li>
      <li>
        <NavLink to="/syllabus" onClick={closeSidebar}>
          <SyllabusIcon />
          Sillabus
        </NavLink>
      </li>
      <li>
        <NavLink
          className={groupsNav.includes(location.pathname) ? "active" : ""}
          to="/groups/waiting"
          onClick={closeSidebar}
        >
          <GroupIcon />
          Qruplar
        </NavLink>
      </li>{" "}
      <li>
        <NavLink
          className={groupsNav.includes(location.pathname) ? "active" : ""}
          to="/quarterly-plan"
          onClick={closeSidebar}
        >
          <QuarterlyPlan />
          Rüblük hədəf planı
        </NavLink>
      </li>
      <li>
        <NavLink to="/room" onClick={closeSidebar}>
          <RoomIcon />
          Otaqlar
        </NavLink>
      </li>
      <li>
        <NavLink to="/tuition-fee" onClick={closeSidebar}>
          <ExpensesIcon />
          Təhsil haqqı
        </NavLink>
      </li>
      <li>
        <NavLink to="/career" onClick={closeSidebar}>
          <CareerIcon />
          Karyera
        </NavLink>
      </li>
      <li>
        <NavLink to="/consultation" onClick={closeSidebar}>
          <MainPanelIcon />
          Lead'lər
        </NavLink>
      </li>
      <li>
        <NavLink to="/workers-plan" onClick={closeSidebar}>
          <MainPanelIcon />
          Lead bölgüsü
        </NavLink>
      </li>
      <li>
        <NavLink to="/sales" onClick={closeSidebar}>
          <SalesIcon />
          Satış
        </NavLink>
      </li>
      <li>
        <NavLink to="/event" onClick={closeSidebar}>
          <EventsIcon />
          Tədbirlər
        </NavLink>
      </li>
      <li>
        <NavLink to="/workers" onClick={closeSidebar} className="admin">
          <AdminIcon />
          Əməkdaşlar
        </NavLink>
      </li>
      <li>
        <NavLink to="/diploma" onClick={closeSidebar}>
          <DiplomaIcon />
          Diplom cədvəli
        </NavLink>
      </li>
      <li>
        <NavLink to="/whereHeard" onClick={closeSidebar}>
          <AdvertisingIcon />
          Reklam növləri
        </NavLink>
      </li>{" "}
      <li>
        <NavLink to="/contracts" onClick={closeSidebar}>
          <ContractTypeIcon />
          Müqavilə növləri
        </NavLink>
      </li>
    </ul>
  );
};

export default SidebarSuperAdmin;
